<form [formGroup]="form">
  <mat-form-field>
    <mat-label>Telefon</mat-label>
    <input formControlName="phone" matInput>
  </mat-form-field>
  <mat-form-field>
    <mat-label>E-post</mat-label>
    <input formControlName="email" matInput>
  </mat-form-field>
</form>